import React, { Component, Fragment } from 'react';
import IconButton from '../Buttons/IconButton';
import { addEvent, removeEvent } from '../../lib/utils';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';
import isEqual from 'lodash/isEqual';
import api from '../../lib/api';
import { CHAT_LINKS } from './utils';

const msgModalIniitalState = {
  isOpen: false,
  head: '',
  body: '',
  footer: null,
};

export default class ChatPlatformLinks extends Component {
  state = {
    saveButtonIsVisible: false,
    editButtonIsVisible: true,
    isEditing: false,
    inputValue: {},
    msgModal: msgModalIniitalState,
  };

  editorRef = React.createRef();

  renderButtons = () => {
    // SAVE BUTTON IS CHECKED AND RENDERED FIRST
    if (this.state.saveButtonIsVisible && this.hasInputChanged()) {
      return (
        <IconButton text="Save" iconClass="edit-pencil" onEditPress={this.onSavePress} />
      );
    }
    // RENDER EDIT BUTTON ON HOVER IF NOT ALREADY EDITING
    if (this.state.editButtonIsVisible && !this.state.isEditing) {
      return (
        <IconButton text="Edit" iconClass="edit-pencil" onEditPress={this.onEditPress} />
      );
    }
    return null;
  };

  onEditPress = () => {
    this.setState({
      isEditing: true,
      saveButtonIsVisible: true,
      inputValue: { ...this.props.value },
    });
    addEvent({
      elem: window,
      type: 'click',
      eventHandle: this.onOutsideEditorClick,
      options: true,
    });
  };

  renderMsgModal = () => {
    const { isOpen, head, body, footer } = this.state.msgModal;

    return (
      <Modal isOpen={isOpen} toggle={this.closeMsgModal}>
        <ModalHeader toggle={this.closeMsgModal}>{head}</ModalHeader>
        {body && <ModalBody>{body}</ModalBody>}
        <ModalFooter>{footer}</ModalFooter>
      </Modal>
    );
  };

  renderInput = () => {
    return (
      <ul>
        {CHAT_LINKS.map(link => (
          <li key={link.patch_key}>
            <div className="key">{link.title}</div>
            <input
              className="value"
              name={link.patch_key}
              onChange={this.handleInputChange}
              value={
                this.state.inputValue[link.patch_key]
                  ? this.state.inputValue[link.patch_key].link
                  : ''
              }
            />
          </li>
        ))}
      </ul>
    );
  };

  renderChildren = () => this.props.children;

  onOutsideEditorClick = e => {
    if (this.hasInputChanged() && !this.state.msgModal.isOpen) {
      if (!this.editorRef.current.contains(e.target)) {
        this.openMsgModal({
          isOpen: true,
          head: 'Do you want to save the changes you made?',
          footer: this.renderModalButtons('Save'),
        });
      }
    } else if (!this.editorRef.current.contains(e.target)) {
      this.resetEditor();
    }
  };

  handleInputChange = e =>
    this.setState({
      inputValue: {
        ...this.state.inputValue,
        [e.target.name]: {
          link: e.target.value,
          platform: e.target.name,
        },
      },
    });

  hasInputChanged = () => {
    const hasChangedBeforeSave = !isEqual(
      Object.values(this.state.inputValue),
      this.props.value ? Object.values(this.props.value) : []
    );

    return hasChangedBeforeSave;
  };

  onSavePress = async () => {
    const { endpoint, patchKey, updateData } = this.props;
    const { inputValue } = this.state;

    try {
      const { data } = await api.patch(endpoint, {
        [patchKey]: Object.values(inputValue),
      });
      if (isEqual(data[patchKey], Object.values(inputValue))) {
        updateData(data);
        this.resetEditor();
        this.closeMsgModal();
      } else {
        this.openMsgModal({
          isOpen: true,
          head: 'Sorry! we could not update your profile.',
          footer: this.renderModalButtons('Try again'),
        });
      }
    } catch (e) {
      this.openMsgModal({
        isOpen: true,
        head: 'Network Error. Try again later',
        footer: this.renderModalButtons(),
      });
    }
  };

  openMsgModal = (args: msgModal) => {
    this.setState({
      msgModal: { ...args },
    });
  };

  closeMsgModal = () => this.setState({ msgModal: msgModalIniitalState });

  resetEditor = () => {
    this.setState({ isEditing: false, saveButtonIsVisible: false });

    removeEvent({
      elem: window,
      type: 'click',
      eventHandle: this.onOutsideEditorClick,
      options: true,
    });
  };

  onCancelPress = () => {
    this.closeMsgModal();
    this.resetEditor();
  };

  renderModalButtons = (primaryBtnTxt?: string) => {
    if (!primaryBtnTxt)
      return (
        <Button color="secondary" onClick={this.onCancelPress}>
          Cancel
        </Button>
      );
    return (
      <Fragment>
        <Button color="primary" onClick={this.onSavePress}>
          {primaryBtnTxt}
        </Button>
        <Button color="secondary" onClick={this.onCancelPress}>
          Cancel
        </Button>
      </Fragment>
    );
  };

  render() {
    return (
      <div className={this.props.className} ref={this.editorRef}>
        {this.renderButtons()}
        {this.state.isEditing ? this.renderInput() : this.renderChildren()}
        {this.state.msgModal.isOpen && this.renderMsgModal()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Profile/ChatPlatformLinks.jsx